import VerticalScrollContainer from './vertical-scroll-container'

export default VerticalScrollContainer
